import * as React from "react";

export const NotFoundPage = () => <div>Looks like you are lost </div>

